export default __webpack_public_path__ + "static/media/solidworks-profile.0e125e47.png";